// Dynamic baseUrl selection based on hostname, using .env variables
// Usage: import baseUrl from './config';
// Matches magellan-search-taqman-ui-react robust hostname detection pattern

let baseUrl =
  process.env.REACT_APP_BASE_URL_LOCAL || "https://www.thermofisher.com";

if (typeof window !== "undefined" && window.location) {
  const { hostname } = window.location;
  let suffix = "_LOCAL";

  // Robust hostname detection pattern matching magellan-search-taqman-ui-react
  if (hostname.includes("www.dev")) {
    suffix = "_DEV";
  } else if (hostname.includes("www.qa") || hostname.includes("qa1")) {
    suffix = "_QA";
    // Handle QA environment variants like qa4
    let qaNum = hostname.split(".")[1]?.split("qa")[1] || "";
    if (qaNum === "4") {
      suffix = "_QA4";
    }
    // Handle China regions
    if (hostname.includes("cn")) {
      suffix = "_QA_CN";
    }
  } else if (hostname.includes("www.thermofisher")) {
    suffix = "_PROD";
    // Handle China regions for production
    if (hostname.includes("cn")) {
      suffix = "_PROD_CN";
    }
  } else if (hostname.includes("www.stage")) {
    suffix = "_STAGE";
  }

  const envUrl = process.env[`REACT_APP_BASE_URL${suffix}`];
  if (envUrl) {
    baseUrl = envUrl;
  } else {
    // Enhanced fallback for QA environment when env var is missing
    if (hostname.includes("qa")) {
      baseUrl = `https://www.qa.thermofisher.com`;
      console.warn(
        `[Config] No env var for ${suffix}, using QA fallback: ${baseUrl}`
      );
    }
  }
}

// Ensure we always have a valid baseUrl
if (!baseUrl) {
  baseUrl = "https://www.thermofisher.com";
}

export default baseUrl;
